import { ref } from 'vue'
import Api from "./Api"
import Image from "@/services/Image"

export function useThemes() {
    const options = ref([])
    const isLoading = ref(false)

    const formatElement = (item) => {
        let value = item["theme_id"] ?? 0
        let name = item["theme_name"] ?? ""
        let hasImage = item["theme_image_host"] && item["theme_image_name"]

        if (value === 0 || name === "") {
            return []
        }

        return [{
            value,
            name,
            image: hasImage ? Image.handle(item["theme_image_host"], item["theme_image_name"], 60, 60) : null
        }]
    }

    const fetchThemes = async () => {
        isLoading.value = true

        try {
            const items = await Api.themes(1000)

            options.value = Object.values(items || {}).flatMap(formatElement)

        } catch (error) {
            console.error("Не удалось загрузить список тем:", error)
        } finally {
            isLoading.value = false
        }
    }

    return {
        options,
        isLoading,
        fetchThemes
    }
}
